// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__XbeQX","wrapper":"styles_wrapper__3xaEv","text":"styles_text__Vosno"};